// extracted by mini-css-extract-plugin
module.exports = {"main":"_34E5fGMqm3FfLsc5q8mEaU","layout":"_1BeNyWTsCBiqXY0TUA7pRT"};